import { IAuthenticationProvider, AuthEnvironment, UIAuthProvider, GetAccessTokenOptions } from "../../interfaces/IAuthenticationProvider";
import { AuthSharedComponent } from "./AuthSharedComponent";
import { AuthErrors, AuthError } from './AuthErrors';
import { ErrorStringFromException } from "../../../utils/utils";

/*
    USSEC stands for "USSEC High security environment".
*/
export class USSECAuthenticationProvider implements IAuthenticationProvider {
    private authSharedComponent: AuthSharedComponent = new AuthSharedComponent();

    Authenticate(): void {

        (<any>OfficeFirstPartyAuth).useMsal3 = true;
        (<any>OfficeFirstPartyAuth).debugging = true;
        (<any>OfficeFirstPartyAuth).authorityOverride = "https://login.microsoftonline.microsoft.scloud";

        try {
            this.authSharedComponent.Authenticate();
        } catch (error) {
            throw new AuthError(AuthErrors.UnableToAuthenticate, ErrorStringFromException(error));
        }
    }

    async GetAccessToken(options: GetAccessTokenOptions): Promise<string> {
        try {
            return await this.authSharedComponent.GetAccessToken(options);
        } catch (error) {
            throw new AuthError(AuthErrors.UnableToFetchToken, ErrorStringFromException(error));
        }
    }

    GetAuthEnvironment(): AuthEnvironment {
        return AuthEnvironment.USSEC;
    }

    SetUIAuthProvider(uiAuthProvider: UIAuthProvider): void {
        this.authSharedComponent.SetUIAuthProvider(uiAuthProvider);
    }
}